import {
  IPromotionRepository,
  IPutPromoDeductionAppliedParams,
  IPutPromoDeductionAppliedResult,
} from "@/core/repositories/promotion";

export class PutPromoDeductionAppliedUseCase {
  constructor(private readonly repo: IPromotionRepository) {}

  async execute(params: IPutPromoDeductionAppliedParams): Promise<IPutPromoDeductionAppliedResult> {
    return this.repo.putPromoDeductionApplied(params);
  }
}
